'use client';

import { useEffect, useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

/**
 * Draws a dialog at the top of the page (a portal into <body>), whatever opened it.
 *
 * Every overlay goes through this. A `fixed` dialog drawn where it is opened is
 * only as high as the stacking layer around it: inside the sticky Camps menu, a
 * sticky navbar or a post card (`relative z-[1]`), it was drawn UNDER the page
 * that follows (owner, 2026-10-14: "Start a Camp is hidden by other
 * components"). At the top of <body> its own z-index is the only one that
 * counts. React context still flows through, so a dialog keeps its providers.
 */
export default function Layer({ children }: { children: ReactNode }) {
  const [host, setHost] = useState<HTMLElement | null>(null);
  useEffect(() => { setHost(document.body); }, []);
  return host ? createPortal(children, host) : null;
}
